var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackspace1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 5.448 21.552 5 21 5H8.372C7.935 5 7.519 5.191 7.234 5.523C6.156 6.779 3.423 9.962 2.241 11.338C2.081 11.525 2 11.757 2 11.989C2 12.22 2.08 12.452 2.24 12.64C3.421 14.02 6.155 17.215 7.234 18.475C7.519 18.808 7.935 19 8.374 19H21C21.552 19 22 18.552 22 18C22 15.423 22 8.577 22 6ZM8.372 6.5H20.5V17.5H8.374L3.659 11.99L8.372 6.5ZM14.009 10.927L15.719 9.217C15.865 9.071 16.058 8.998 16.25 8.998C16.654 8.998 17 9.322 17 9.747C17 9.94 16.927 10.131 16.781 10.278L15.07 11.989L16.798 13.717C16.945 13.864 17.018 14.056 17.018 14.247C17.018 14.674 16.669 14.998 16.268 14.998C16.076 14.998 15.884 14.925 15.737 14.779L14.009 13.05L12.281 14.779C12.135 14.925 11.942 14.998 11.75 14.998C11.349 14.998 11 14.674 11 14.247C11 14.056 11.073 13.864 11.22 13.717L12.948 11.989L11.16 10.202C11.014 10.054 10.941 9.863 10.941 9.67C10.941 9.245 11.287 8.921 11.692 8.921C11.884 8.921 12.076 8.994 12.222 9.14L14.009 10.927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace1);
export default __webpack_public_path__ + "static/media/backspace1.36af2a8a4d820fbc68b88cf888b09d98.svg";
export { ForwardRef as ReactComponent };